import { GetTimeseriesRequest } from "../types/timeseries";
import {
  getCountryAdministrativeUnitService,
  getCountriesService,
} from "../services/countries";
import { useQuery } from "react-query";
import { useMatch } from "react-router-dom";
import { useAuthContext } from "./useAuthContext";
import useAggregationLevel from "./useAggregationLevel";

export type UseTimeseries = GetTimeseriesRequest;

const useCountries = ({
  country,
  aggregationLevel,
  useGeometry,
  enabled,
}: {
  country?: string;
  aggregationLevel?: string;
  useGeometry?: boolean;
  enabled?: boolean;
} = {}) => {
  const {
    getAggregationLevel: { isLoading },
  } = useAggregationLevel();
  const isDashboardPage = useMatch("/dashboard/get-started");
  const { parsedToken } = useAuthContext();
  const { email: userEmail } = parsedToken || {};

  const isSystemType =
    aggregationLevel === "0" ||
    aggregationLevel === "1" ||
    aggregationLevel === "2";

  const getCountryAdministrativeUnit = useQuery(
    [
      "countries",
      "administrativeUnit",
      country,
      aggregationLevel,
      userEmail,
      isSystemType,
    ],
    async () => {
      return await getCountryAdministrativeUnitService({
        aggregationLevel,
        country,
        type: isSystemType ? "system" : "user",
      });
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
      enabled:
        !isDashboardPage &&
        !!aggregationLevel &&
        aggregationLevel !== "0" &&
        !!country &&
        !isLoading,
      // !!selectedType,
    },
  );

  const getCountries = useQuery(
    ["countryGeometry"],
    async () => {
      return await getCountriesService({ useGeometry });
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
      // enabled: false,
    },
  );

  return {
    getCountryAdministrativeUnit,
    getCountries,
  };
};

export default useCountries;
